import { get, some, uniqBy } from 'lodash';
import { applicationTypes } from 'constants/scripts';

import {
  getApplicationsByType,
  getApplicationsForZoneByType,
  getApplicationsWithNumericalRate } from 'scripts/zones/selectors';

export const getProductApplicationsForZones = (zones) => {
  return getApplicationsByType({ zones, applicationType: applicationTypes.APPLICATION });
};
export const getFertilizerApplicationsForZones = (zones) => {
  return getApplicationsByType({ zones, applicationType: applicationTypes.FERTILIZER });
};
export const getStabilizerApplicationsForZones = (zones) => {
  return getApplicationsByType({ zones, applicationType: applicationTypes.STABILIZER });
};

export const getProductApplicationsForZone = (zone) => {
  return getApplicationsForZoneByType({ zone, applicationType: applicationTypes.APPLICATION });
};

export const getFertilizerApplicationsForZone = (zone) => {
  return getApplicationsForZoneByType({ zone, applicationType: applicationTypes.FERTILIZER });
};

export const getStabilizerApplicationsForZone = (zone) => {
  return getApplicationsForZoneByType({ zone, applicationType: applicationTypes.STABILIZER });
};

export const hasFertilizerApplicationsForZones = (zones) => {
  const liquidApplications = getFertilizerApplicationsForZones(zones);
  return some(liquidApplications, (applications) => {
    return Number.isFinite(get(applications[0], 'rate.q'));
  });
};

export const getNumZonesWithFertilizerApplications = (zones) => {
  const fertilizerApplications = getFertilizerApplicationsForZones(zones);
  const fertilizerApplicationsWithNumericalValue = getApplicationsWithNumericalRate(fertilizerApplications);
  return fertilizerApplicationsWithNumericalValue.length;
};

/**
 * @param {object} params
 * @param {object} params.zones
 * @param {string} applicationType
 */
export const getProductsInZones = ({ zones, applicationType }) => {
  const products = Object.values(zones).map((zone) => {
    return get(zone, `meta.applications.${applicationType}[0].product`);
  });
  return uniqBy(products, 'id');
};

export const getNumZonesWithApplications = ({ zones, applicationType }) => {
  const applications = getApplicationsByType({ zones, applicationType });
  const applicationsWithNumericalValue = getApplicationsWithNumericalRate(applications);
  return applicationsWithNumericalValue.length;
};

export const getFertilizerApplicationProductsInZones = (zones) => {
  const products = Object.values(zones).map((zone) => {
    return get(zone, `meta.applications.${applicationTypes.FERTILIZER}[0].product`);
  });
  return uniqBy(products, 'id');
};

export const getFertilizerSummaryForZone = (zone) => getFertilizerApplicationsForZone(zone)[0];

export const hasStabilizerApplicationsForZones = (zones) => {
  const stabilizerApplications = getStabilizerApplicationsForZones(zones);
  return some(stabilizerApplications[0], (application) => !!get(application, 'id'));
};
